import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Divider } from "@mui/material";
import { Close, BugReport, Science } from "@mui/icons-material";
import {LightHoverButton} from "../button/ButtonVariants";
export interface SupportModalProps {
    open: boolean;
    onClose: () => void;
}

export function SupportModal(props: SupportModalProps) {
    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6">Support</Typography>
                <IconButton onClick={props.onClose}>
                    <Close fontSize="large" />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent>
                <Box sx={{ mb: 3, display: "flex", gap: 6, alignItems: "center", justifyContent: "space-between" }}>
                    <Typography variant="subtitle1" fontWeight={700} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        Feature vorschlagen <Science />
                    </Typography>
                    <LightHoverButton
                        sx={{ minWidth: "17rem" }}
                        href="mailto:info@flottbruuk.de?subject=Featurewunsch%20in%20flottbruuk"
                    >
                        info@flottbruuk.de
                    </LightHoverButton>
                </Box>

                <Divider />

                <Box sx={{ mt: 3, display: "flex", gap: 6, alignItems: "center", justifyContent: "space-between"  }}>
                    <Typography variant="subtitle1" fontWeight={700} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        Fehler melden <BugReport />
                    </Typography>
                    <LightHoverButton
                        sx={{ minWidth: "17rem" }}
                        href="mailto:support@flottbruuk.de?subject=Fehler%20in%20flottbuuk"
                    >
                        support@flottbruuk.de
                    </LightHoverButton>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
